import { useState } from '@wordpress/element'

export const Tooltip = ({ text, children, height = null }) => {
  const [isHovered, setIsHovered] = useState(false)

  const styles = {
    container: {
      position: 'relative',
      display: 'inline-block',
      cursor: 'pointer',
      ...(height && { height: `${height}px` }),
    },
    tooltip: {
      visibility: isHovered ? 'visible' : 'hidden',
      width: '200px',
      backgroundColor: 'black',
      color: '#fff',
      textAlign: 'left',
      borderRadius: '6px',
      padding: '10px',
      position: 'absolute',
      top: '100%',
      left: '-100%',
      zIndex: '1',
    },
  }

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  return (
    <div
      style={styles.container}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      <div style={styles.tooltip}>{text}</div>
    </div>
  )
}
